import { GameMode } from "./game";
import { TrainingLevel } from "./playerAccount";

export type GameModeName = 'solo' | 'ranked' | 'multiplayer' | 'tutorial';
export type HostTransport = 'steam' | 'browser';
export type GameTotals = { played: number, wins: number, losses: number };
export type GameTotalsByMode = Partial<Record<GameModeName, GameTotals>>;

export type ReplayGameStats = {
	gameId: string,
	trainingLevel: string,
	result: 'won' | 'lost' | 'abandoned',
	round: number,
	mode: GameModeName,
	rank?: number,
	opponentRank?: number,
	opponentReplayID?: string,
	playTimeSeconds?: number,
	totals?: GameTotalsByMode,
	playedToday?: number, //UTC, like the upload dates
	hostTransport?: HostTransport, //Multiplayer only
}

export function makeReplayGameStats(
	trainingLevel: TrainingLevel,
	result: ReplayGameStats['result'],
	round: number,
	players: Array<{ isBot: boolean }>,
	gameId: string,
	opponentReplayID: string | undefined,
): ReplayGameStats {
	const stats: ReplayGameStats = { gameId, trainingLevel: TrainingLevel[trainingLevel], result, round, mode: getGameModeName(players, trainingLevel) };
	if (stats.mode === 'ranked' && opponentReplayID) stats.opponentReplayID = opponentReplayID;
	return stats;
}

export function getGameModeName(players: Array<{ isBot: boolean }>, trainingLevel: TrainingLevel): GameModeName {
	if (trainingLevel !== TrainingLevel.Trained) return 'tutorial';
	const humans = players.filter(player => !player.isBot).length;
	return humans > 1 ? 'multiplayer' : players.some(player => player.isBot) ? 'ranked' : 'solo';
}

export function gameModeToName(mode: GameMode, trainingLevel: TrainingLevel): GameModeName {
	if (trainingLevel !== TrainingLevel.Trained) return 'tutorial';
	return mode === GameMode.Solo ? 'solo' : mode === GameMode.Asynchronous ? 'ranked' : 'multiplayer';
}
